export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-indigo-900 via-purple-900 to-purple-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/0d06d78a-ab14-47db-8572-99c1e3ed4b3e.png" 
                alt="David's Website Design Logo" 
                className="h-10 w-auto"
              />
              <h4 className="text-xl font-bold font-['Poppins']">Web Design El Paso</h4>
            </div>
            <p className="text-purple-200 text-sm leading-relaxed mb-6">
              Leading <strong className="text-white">web design El Paso</strong> agency specializing in SEO, digital marketing, and custom website solutions.
            </p>
            <address className="text-purple-200 text-sm not-italic">
              <strong className="text-white block mb-2">We are a real locally owned business.</strong>
              1000 Duskin Dr<br />
              El Paso, TX 79907
            </address>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 font-['Poppins']">Our Services</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">Web Design El Paso</a></li>
              <li><a href="#services" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">SEO Optimization</a></li>
              <li><a href="#services" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">Social Media Marketing</a></li>
              <li><a href="#services" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">Content Marketing</a></li>
              <li><a href="#services" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">PPC Advertising</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 font-['Poppins']">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">Latest Features</a></li>
              <li><a href="#full-service" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">Turnkey Service</a></li>
              <li><a href="#contact" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">Get Free Quote</a></li>
              <li><a href="#contact" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">Free Consultation</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 font-['Poppins']">Connect With Us</h4>
            <div className="flex gap-4 mb-6">
              <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
            <p className="text-purple-200 text-sm">
              Follow us for the latest tips on <strong className="text-white">web design in El Paso</strong> and digital marketing strategies.
            </p>
          </div>
        </div>

        <div className="border-t border-purple-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-purple-200 text-sm">
              © 2025 David&apos;s Website Design. All rights reserved.
            </p>
            <a href="/privacy-policy" className="text-purple-200 hover:text-white text-sm transition-colors cursor-pointer">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
